import { render, staticRenderFns } from "./MyPetitionsList.vue?vue&type=template&id=217fc39e&scoped=true&"
import script from "./MyPetitionsList.vue?vue&type=script&lang=ts&"
export * from "./MyPetitionsList.vue?vue&type=script&lang=ts&"
import style0 from "./MyPetitionsList.vue?vue&type=style&index=0&id=217fc39e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217fc39e",
  null
  
)

export default component.exports